import BTButton from "@common-components/bt-button/bt-button";
import MenuTriggerTooltip from '@common/components/menu-trigger-tooltip/menu-trigger-tooltip';
import BtEditableBox from "@common-components/tasks/bt-editable-box/bt-editable-box";
import { PersonAvatar } from "@common-components/tasks/person-avatar/person-avatar";
import { Board } from "@common-models/board";
import { AvatarGroup, Menu, Tooltip, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import {
  boardsActions
} from "@common-reducers/BoardsReducer";
import { getSelectedBoardCompleteUserList, getSelectedBoardId, isCurrentUserWorkspaceOwnerOrMember } from "@common-reducers/BoardsSelectors";
import { DBBoardsThunks, boardsSelectors, isTempId } from "@common-reducers/DBServiceThunks";
import { mainSliceActions } from "@common-reducers/MainReducer";
import { pickerDialogActions } from "@common-reducers/PickerDialogReducer";
import { taskActions } from "@common-reducers/TasksReducer";
import { useAnalyticsService } from "@common-reducers/hooks/use-analytics-service";
import { AnalyticsService } from "@common-services/analytics-service";
import EmojiPicker, { Theme } from "@/common/components/lazy-emoji-picker/lazy-emoji-picker";
import React, { ReactElement, useEffect } from "react";
import { BsPeopleFill, BsReverseListColumnsReverse, BsThreeDots } from "react-icons/bs";
import { TbArrowBigUp } from "react-icons/tb";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { recycleActions } from "@common-reducers/RecycleBinReducer";
import { activeSubscriptionSelector, selectIsDarkMode } from "@common-reducers/UserSelectors";
import { isExtensionContextOrWhatsappView } from "@common-services/detect-context";
import { namespace } from "@common-config/constants";
import { useTranslation } from "react-i18next";
import { theme } from "@common/theme";
import { useAppDispatch, useAppSelector } from "@common/reducers/hooks/store.hook";
import NotificationsButton from "./notifications-button";
import classes from "./tasks-header.module.scss";
import ToggleDarkMode from "./toggle-dark-mode/toggle-dark-mode";
import BoardMenuPickerShadcn from "@common-components/tasks/board-menu-picker/board-menu-picker-shadcn";
type Props = {
  isDisplayTasksHeader?: boolean;
  isDisplayBoardNameAndIcon?: boolean;
  isDisplaySharedUsersAvatar?: boolean;
  isDisplayShareButton?: boolean;
  isDisplayMenuButton?: boolean;
  isDisplayDarkBrightModeButton?: boolean;
  isDisplayUpgradeButton?: boolean;
  isDisplayActivityButton?: boolean;
  isDisplayNotificationsButton?: boolean;
  isDisplayBackButton?: boolean;
  onBackClick?: () => void;
  backTooltip?: string;
}
export default function TasksHeader({
  isDisplayTasksHeader = true,
  isDisplayBoardNameAndIcon = true,
  isDisplaySharedUsersAvatar = true,
  isDisplayShareButton = true,
  isDisplayMenuButton = true,
  isDisplayDarkBrightModeButton = true,
  isDisplayUpgradeButton = true,
  isDisplayActivityButton = true,
  isDisplayNotificationsButton = true,
  isDisplayBackButton = false,
  onBackClick,
  backTooltip = 'Back',
}: Props): ReactElement {
  const { t } = useTranslation(namespace);
  const [emojiAnchorEl, setEmojiAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(emojiAnchorEl);
  const handleEmojilClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setEmojiAnchorEl(event.currentTarget);
  };
  const handleEmojiClose = () => {
    setEmojiAnchorEl(null);
  };
  const analyticsService: AnalyticsService = useAnalyticsService();

  // const isDesktopGreaterThen1300 = useMediaQuery(theme.breakpoints.up(1300));
  const dispatch = useAppDispatch();
  const selectedBoardId = useAppSelector(getSelectedBoardId);
  //const getActiveWorkSpaceMembers = useAppSelector(getWorkspaceMembers);
  //const canInviteUsers = isCurrentBoardOwner || isCurrentWorkspaceOwner;
  const canInviteUsers = useAppSelector(isCurrentUserWorkspaceOwnerOrMember);
  const isBoardRenameForced = useAppSelector((state) => state.BoardsReducer.isRenameBoard)
  const workspaceSubscription = useAppSelector(activeSubscriptionSelector);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const setEditMode = (value: boolean) => {
    if (value === false) {
      dispatch(boardsActions.setRenameBoard(false))
    }
  }

  // If 'selectIsDarkMode' returns true, set 'emoTheme' to "Theme.DARK"; otherwise, set it to "Theme.LIGHT".
  const emoTheme = useAppSelector(selectIsDarkMode) ? Theme.DARK : Theme.LIGHT;


  useEffect(() => {
    // dispatch(taskActions.setIsTasksPanelOpen(true)); setting isTasksPanelOpen to true here will mess up the bulk campaign feature in the extension, as it renders <TaskView/>
  }, []);

  const archiveOrDeletedAlertType = useAppSelector(state => state.RecycleBinReducer.archiveOrDeletedAlertType);

  const openArchive = () => {

    dispatch(recycleActions.setArchiveShown(false));
    dispatch(recycleActions.setArchivedOrDeletedData([]));
    dispatch(recycleActions.setSearchText(''));
    dispatch(recycleActions.setArchivedOrDeletedBulkItems([]));
    dispatch(recycleActions.setArchivedOrDeletedSnackMessage({ message: '', type: archiveOrDeletedAlertType }))
    dispatch(recycleActions.setFilters({
      type: [],
      date: '',
      board: []
    }));
    dispatch(recycleActions.setArchiveShown(true));


  }


  const board: Board = useAppSelector((state) =>
    boardsSelectors.selectById(state, selectedBoardId)
  );
  const userList = useAppSelector(getSelectedBoardCompleteUserList);

  console.log('userList:', userList)
  // const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)
  // const [rename, setRename] = useState<Boolean>(false)
  // const open = Boolean(anchorElementId);

  const extraFilesTheme = {
    ".MuiAvatar-circular": {
      height: "32px",
      width: "32px",
      background: "var(--color-primary)",
      color: "white",
      fontSize: "10px",
      boxShadow: "rgb(0 0 0 / 10%) 2px 2px 2px",
      border: "1px solid rgb(186, 186, 186)",
    },
  };

  function openMenu(_event: React.MouseEvent, board: Board) {
    dispatch(
      pickerDialogActions.setPickerTypeAndId({
        pickerAnchorId: "task-header-board-menu-options",
        pickerProps: {
          boardId: board._id,
          type: "board-menu-options",
        },
      })
    );
  }

  const openInviteModal = () => {

    dispatch(mainSliceActions.inviteModalOpen(true))
    dispatch(taskActions.setTaskViewSideDrawerOpenWith("InviteUserModal"));


  }

  function saveChanges(value: string) {
    if (value) {
      dispatch(
        DBBoardsThunks.patch({
          entity: {
            ...board,
            name: value,
            isBoardNameEditting: false,
          },
        })
      );
      dispatch(boardsActions.openBoardItemMenu(false));
      dispatch(boardsActions.setMenuAnchorEl(null));
      dispatch(boardsActions.setRenameBoard(false))
      dispatch(boardsActions.setBoardEditModeByBoardId(""));
    }
  }
  const inputTheme = {
    color: "var(--color-primary)",
    width: "100%",
    padding: "0 10px",
    fontSize: "24px",
    fontWeight: "800",
    borderRadius: "8px",
    border: "1px solid var(--color-accent)",
    backgroundColor: "var(--tasks-group-bg)",
    fontFamily: "'Poppins', 'Assistant', sans-serif",
    "& .MuiInputBase-input": {
      padding: "0",
    },
    // minWidth: 500
  };
  const textTheme = {
    color: "var(--color-primary)",
    fontSize: "24px",
    padding: "0 10px",
    borderRadius: "8px",
    fontWeight: "800",
    fontFamily: "'Poppins', 'Assistant', sans-serif",
    "&:hover": {
      border: "1px dashed var(--tasks-text-secondary)",
    },
    // minWidth: 200
  };

  const displayPanelSelectedBorder = '2px solid #579bfc';

  function setBoardIcon(arg1: any) {
    const emoji = arg1.emoji;
    dispatch(
      DBBoardsThunks.patch({
        entity: { ...board, titleIcon: `${emoji}` },
      })
    );
  }




  return (
    <>
      {isDisplayTasksHeader &&
        <Stack
          direction="row"
          className={classes.headerContainer}
          alignItems="center"
          justifyContent="space-between"
          flex="auto"
        >
          {/* left side */}
          {isDisplayBoardNameAndIcon &&
            <Stack direction='row' gap="16px" width="100%" alignItems="center">
              {/* back button */}
              {isDisplayBackButton && onBackClick && (
                <Tooltip title={backTooltip} placement="bottom" arrow>
                  <button
                    onClick={onBackClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '8px',
                      background: 'transparent',
                      border: '1px solid var(--color-border, #e5e7eb)',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      color: 'var(--color-primary)',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'var(--color-hover, #f3f4f6)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                    }}
                  >
                    <ArrowLeft size={20} />
                  </button>
                </Tooltip>
              )}
              
              {/* board icon */}
              <span
                style={{ cursor: "pointer", fontSize: "24px" }}
                onClick={handleEmojilClick}
              >
                {board?.titleIcon ?? "😜"}
              </span>
      
              <Menu
                anchorEl={emojiAnchorEl}
                open={open}
                onClose={handleEmojiClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '8px !important',
                  },
                  '& .MuiList-root': {
                    padding: 0,
                  },
                }}>
                <div className={classes.setBoardIconPicker}>
                  
                  <EmojiPicker theme={emoTheme} onEmojiClick={setBoardIcon} />
                </div>
              </Menu>



              {/* Board name + optional agent-written description subtitle. The
                  subtitle is truncated with a tooltip carrying the full text. */}
              <Stack direction="column" gap="2px" sx={{ minWidth: 0 }}>
                <BtEditableBox
                  data-testid="tasks-header-board-name-bteditablebox"
                  inputSx={inputTheme}
                  disabled={isTempId(board?._id ?? null)}
                  boxSx={textTheme}
                  forceEditMode={isBoardRenameForced}
                  text={board?.name}
                  onValueUpdate={(value) => {
                    saveChanges(value);
                  }}
                  onEditModeChange={(value) => setEditMode(value)}

                />
                {board?.description && (
                  <Tooltip title={board.description} placement="bottom-start" arrow>
                    <span
                      style={{
                        color: 'var(--tasks-text-secondary, #676879)',
                        fontSize: '13px',
                        padding: '0 10px',
                        maxWidth: '520px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {board.description}
                    </span>
                  </Tooltip>
                )}
              </Stack>
            </Stack>
          }


          {/* right side */}
          <Stack direction="row" sx={{ marginInlineStart: 2 }}>
            <div className={classes.header_column_right}>
              {(

                <>
                  {isDisplaySharedUsersAvatar && !isMobile &&
                    <div className={classes.members}>
                      <AvatarGroup onClick={() => dispatch(mainSliceActions.inviteModalOpen(true))} sx={extraFilesTheme} max={5}>
                        {userList.sort(function (a, b) {
                          return a.hasOwnProperty("userId") ? -1 : b.hasOwnProperty("userId") ? 1 : 0
                        }).map((person, index) => (
                          <div style={{ opacity: person?.status === "active" ? "1" : '0.5' }} key={index} className={classes.member}>
                            <PersonAvatar
                              size={32}
                              email={person.email}
                              profileImg={person?.profile?.profileImg}
                              lastName={(person?.profile?.lastName === 'undefined' || person?.profile?.lastName === undefined) ? ' ' : person?.profile.lastName}
                              firstName={person?.profile?.firstName}
                              toolTip={true}
                            />
                          </div>
                        ))}
                      </AvatarGroup>
                    </div>
                  }
                  {isDisplayActivityButton && !isMobile &&
                    <button
                      className={classes.button}
                      disabled={isTempId(board?._id ?? null)}
                      onClick={() => {
                        dispatch(mainSliceActions.inviteModalOpen(true))
                        dispatch(taskActions.setTaskViewSideDrawerOpenWith("ActivityLog"));
                      }
                      }
                    >
                      <BsReverseListColumnsReverse />
                      <span>{t('tasksHeader.activity')}</span>
                    </button>
                  }
                  {isDisplayShareButton && !isMobile &&
                    <button
                      className={classes.button}
                      disabled={isTempId(board?._id ?? null)}
                      onClick={openInviteModal
                      }
                    >
                      <BsPeopleFill />
                      <span>{t('tasksHeader.shareBoard')}</span>
                    </button>
                  }
                </>

              )}

        

              {isDisplayMenuButton && !isMobile && (

                // Shut while its menu or the dialog it launched is open — see useMenuTriggerTooltip.
                <MenuTriggerTooltip title={t('tasksHeader.boardOptions')} placement="bottom">
                  {(onMenuOpenChange) => <BoardMenuPickerShadcn boardId={board?._id ?? ''} onOpenChange={onMenuOpenChange} />}
                </MenuTriggerTooltip>



              )}
            </div>

            {isDisplayNotificationsButton && <NotificationsButton />}



            {isDisplayDarkBrightModeButton && !isMobile && <ToggleDarkMode />}
            {(!workspaceSubscription || !workspaceSubscription?.isActive) && !isExtensionContextOrWhatsappView() && isDisplayUpgradeButton && !isMobile &&
              <Link to="/account-subscription" onClick={() => {
                analyticsService.event('switch_to_upgrade', {
                  category: "upgradeFromTopHeader",
                  action: 'upgrade plan',
                });
              }}>
                <BTButton startIcon={<TbArrowBigUp size={"14"} />} sx={{ width: "150px", marginInlineStart: "8px" }} btvariant="pink"  >
                  {t('tasksHeader.upgrade')}
                </BTButton>
              </Link>
            }

            {/* <button
              className={classes.button}
              onClick={() => {
                openArchive()
              }
              }
            >
              <Archive />
              <span>Archive</span>
            </button> */}


          </Stack>
        </Stack >
      }
    </>
  );
}
